import React, { useContext } from 'react';
import { LanguageProvider, LanguageContext } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

const AppContent = () => {
  const { language } = useContext(LanguageContext);
  
  return (
    <div className="App" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
